var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(`${_vm.dayString}天${_vm.hourString}小时${_vm.minuteString}分${_vm.secondString}秒 `))])
}
var staticRenderFns = []

export { render, staticRenderFns }